import domain from "@/environment";
import axios from "axios";

const state = {
  processus: [],
  processusDetail: null,
  processusLoading: false,
  processusTotal: 0,
};

const getters = {
  getProcessus: (state) => state.processus,
  getProcessusDetail: (state) => state.processusDetail,
  getProcessusLoading: (state) => state.processusLoading,
  getProcessusTotal: (state) => state.processusTotal,
};

const mutations = {
  SET_PROCESSUS(state, payload) {
    state.processus = Array.isArray(payload) ? payload : [];
  },
  SET_PROCESSUS_DETAIL(state, payload) {
    state.processusDetail = payload;
  },
  SET_PROCESSUS_LOADING(state, payload) {
    state.processusLoading = payload || false;
  },
  SET_PROCESSUS_TOTAL(state, payload) {
    state.processusTotal = payload || 0;
  },
};

const actions = {
  /**
   * GET /api/processus - Liste des processus
   */
  async fetchProcessus({ commit }, payload = {}) {
    commit("SET_PROCESSUS_LOADING", true);
    const params = {};
    if (payload.page) params.page = payload.page;
    if (payload.per_page) params.per_page = payload.per_page;
    if (payload.search) params.search = payload.search;
    if (payload.entreprise_id) params.entreprise_id = payload.entreprise_id;
    try {
      const response = await axios.get(domain + "/processus", {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
        params,
      });
      const data = response.data?.data ?? response.data;
      const list = Array.isArray(data) ? data : (data?.data ?? []);
      const total = data?.total ?? list.length;
      commit("SET_PROCESSUS", list);
      commit("SET_PROCESSUS_TOTAL", total);
      commit("SET_PROCESSUS_LOADING", false);
      return { data: list, total };
    } catch (error) {
      commit("SET_PROCESSUS_LOADING", false);
      throw error.response?.data?.message ?? error.message;
    }
  },

  /**
   * GET /api/processus/{id} - Afficher un processus
   */
  async fetchProcessusById({ commit }, id) {
    commit("SET_PROCESSUS_LOADING", true);
    try {
      const response = await axios.get(domain + "/processus/" + id, {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
      });
      const data = response.data?.data ?? response.data;
      commit("SET_PROCESSUS_DETAIL", data);
      commit("SET_PROCESSUS_LOADING", false);
      return data;
    } catch (error) {
      commit("SET_PROCESSUS_LOADING", false);
      throw error.response?.data?.message ?? error.message;
    }
  },

  /**
   * POST /api/processus - Créer un processus
   */
  async createProcessus({ commit }, payload) {
    commit("SET_PROCESSUS_LOADING", true);
    try {
      const response = await axios.post(domain + "/processus", payload, {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
      });
      const data = response.data?.data ?? response.data;
      commit("SET_PROCESSUS_LOADING", false);
      return data;
    } catch (error) {
      commit("SET_PROCESSUS_LOADING", false);
      throw error.response?.data?.message ?? error.message;
    }
  },

  /**
   * PUT /api/processus/{id} - Modifier un processus
   */
  async updateProcessus({ commit }, { id, ...payload }) {
    commit("SET_PROCESSUS_LOADING", true);
    try {
      const response = await axios.put(domain + "/processus/" + id, payload, {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
      });
      const data = response.data?.data ?? response.data;
      commit("SET_PROCESSUS_LOADING", false);
      return data;
    } catch (error) {
      commit("SET_PROCESSUS_LOADING", false);
      throw error.response?.data?.message ?? error.message;
    }
  },

  /**
   * PUT /api/processus/{id} - Activer/Désactiver un processus
   */
  async toggleProcessusActive(_context, { id, active, entreprise_id }) {
    try {
      const payload = {
        active: active,
        entreprise_id: entreprise_id
      };
      
      const response = await axios.put(domain + "/processus/" + id, payload, {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
      });
      
      const data = response.data?.data ?? response.data;
      return data;
    } catch (error) {
      throw error.response?.data?.message ?? error.message;
    }
  },

  /**
   * GET /api/processus - Récupérer le processus actif par entreprise_id
   */
  async fetchActiveProcessusByEntreprise(_context, entrepriseId) {
    if (!entrepriseId) return null;
    try {
      const response = await axios.get(domain + "/processus", {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
        params: {
          entreprise_id: entrepriseId,
          active: 1,
          per_page: 100,
        },
      });
      const data = response.data?.data ?? response.data;
      const list = Array.isArray(data) ? data : (data?.data ?? []);
      const activeProcessus = list.find((p) => p.active) || list[0];
      return activeProcessus ? activeProcessus.id : null;
    } catch (error) {
      return null;
    }
  },

  /**
   * DELETE /api/processus/{id} - Supprimer un processus
   */
  async deleteProcessus({ commit }, id) {
    commit("SET_PROCESSUS_LOADING", true);
    try {
      await axios.delete(domain + "/processus/" + id, {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
      });
      commit("SET_PROCESSUS_LOADING", false);
      return true;
    } catch (error) {
      commit("SET_PROCESSUS_LOADING", false);
      throw error.response?.data?.message ?? error.message;
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
